module.exports = __webpack_public_path__ + "static/img/i-step2.28035f57.png";